module.exports = __webpack_public_path__ + "static/media/minus.0ced6871.svg";